import upgreenIcon from 'assets/icons/up-green.svg';
import React, { Component } from 'react';
import { Cell, Label, Pie, PieChart, ResponsiveContainer } from 'recharts';
import './total-asset.style.scss';

function CustomLabel({ viewBox, value1, value2 }) {
  const { cx, cy } = viewBox;
  return (
    <svg className='recharts-text recharts-label' textAnchor='middle' dominantBaseline='central'>
      <text x={cx} y={cy - 4}>
        <tspan
          x={cx}
          dy='0em'
          alignmentBaseline='middle'
          fontSize='20'
          fill='#0B0B0A'
          fontWeight={600}>
          {value1}
        </tspan>
        <tspan x={cx} dy='1.5em' fontSize='14' fill='#929292'>
          {value2}
        </tspan>
      </text>
    </svg>
  );
}

export default class TotalAssetUp extends Component {
  render() {
    const data = [
      { name: 'Group A', value: 90 },
      { name: '', value: 10 },
    ];
    const data2 = [{ name: '', value: 100 }];

    const COLORS = ['#FBC83A', 'transparent'];

    return (
      <div className='total-asset-container-up'>
        <ResponsiveContainer width={120} height={120}>
          <PieChart>
            <Pie
              animationDuration={0}
              paddingAngle={0}
              data={data2}
              dataKey='value'
              cx='50%'
              cy='50%'
              outerRadius={60}
              innerRadius={40}
              startAngle={90}
              endAngle={-450}>
              {data2.map((entry, index) => (
                <Cell key={`cell-${index}`} fill='#EBEBEB' borderWidth={0} stroke={0} />
              ))}
            </Pie>
            <Pie
              paddingAngle={0}
              data={data}
              dataKey='value'
              cx='50%'
              cy='50%'
              outerRadius={60}
              innerRadius={40}
              startAngle={90}
              endAngle={-450}>
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                  cornerRadius={10}
                  stroke={0}
                />
              ))}
              <Label
                width={30}
                position='center'
                content={<CustomLabel value1={'95%'} value2={'Target'} />}
              />
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <div className='total-asset-right'>
          <div className='total-asset-title'>TOTAL ASSET</div>
          <divp>
            <span className='total-asset-price'>181,438</span>
            <span className='total-asset-price-unit'>bil. VND</span>
          </divp>
          <div className='total-asset-trend'>
            <img src={upgreenIcon} alt='' />
            30%
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/Raroc/Dashboard/OverviewWholeBank/components/TotalAsset/TotalAssetUp.js